import '@babel/polyfill';
jQuery(function ($) {
    console.log('gens.jsが読みこまれた');
    $('body').addClass('jquery-add-class');
});
const clientW = window.innerWidth;
const spSize = 768;
const clientSp = clientW < spSize;
const villaSwiper = () => new Swiper('.villa-swiper', {
    loop: true,
    slidesPerView: 2,
    breakpoints: {
        768: {
            slidesPerView: 3,
        }
    },
    centeredSlides: true,
    centeredSlidesBounds: true,
    speed: 8000,
    allowTouchMove: false,
    spaceBetween: 0,
    autoplay: {
        delay: 1,
        disableOnInteraction: false
    }
});
villaSwiper();
const landscapeSwiper = () => new Swiper('.landscape-swiper', {
    loop: true,
    slidesPerView: 1,
    autoplay: {
        delay: 5000
    },
    pagination: {
        el: '.landscapeSwiper-pagination'
    },
    navigation: {
        nextEl: '.landscapeSwiper-button-next',
        prevEl: '.landscapeSwiper-button-prev'
    }
});
landscapeSwiper();
const singleVillaThumbnail = new Swiper('.single-villa-thumbnail', {
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    allowTouchMove: false
});
const singleVillaSwiper = new Swiper('.single-villa-swiper', {
    slidesPerView: 1,
    loop: true,
    thumbs: {
        swiper: singleVillaThumbnail
    },
    speed: 1000
});
